import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Qs from "qs";
import router from "../router/index";

import store from "../store";
import api from "./interface";
import {showLoading, hideLoading} from "../components/Loading";

const vue = new Vue();

axios.defaults.timeout = 30000;
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;
axios.defaults.retryCount = 0;

const resInterceptors = axios.interceptors.response.use(
    undefined,
    resRetryInterceptor
);

function resRetryInterceptor(err) {
    const config = err.config;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err);

    // Check if we've maxed out the total number of retries
    if (config.retryCount >= config.retry) {
        // Reject with the error
        axios.interceptors.response.eject(resInterceptors);
        return Promise.reject(err);
    }

    // Increase the retry count
    config.retryCount += 1;
    // Create new promise to handle exponential backoff
    const backoff = new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, config.retryDelay || 1);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function () {
        return axios.request(config);
    });
}

function Axios() {
    this.isLoginOut = false;
    this.requestQueue = [];
}

Axios.prototype.success = function (res) {
    hideLoading();
    const code = ~~res.data.errorcode || ~~res.data.code;
    // code === 200(post) code === 0(get) 为成功，直接返回，其余转错误处理
    if (code == 201) {
        this.isLoginOut = true;
        vue.$alert("登录信息已失效，请重新登录", "提示", {
            confirmButtonText: "确定",
            callback: () => {
                // this.isLoginOut = false;
                window.location.replace(window.location.origin + "/login");
                // bolRedirect && (window.location.href = "/login?redirect_uri=" + encodeURIComponent(window.location.pathname + window.location.search ));
            }
        });
        return;
    }
    return (code !== 200 && code !== 0) ? Promise.reject(res) : res.data;
};


Axios.prototype.error = function (err) {
    hideLoading();
    // 默认请求超时
    let response = {
        errorcode: 500,
        errordesc: "网络较差，请稍后重试"
    };
    // 返回请求500错误
    if (err.response && err.response.status == 500) {
        response = {
            errorcode: 500,
            errordesc: "连接服务器失败，请稍后重试"
        };
    }

    // 对返回值赋值
    Object.assign(response, err.data);

    // 处理errorcode 和 code
    response.errorcode = response.errorcode || response.code;
    response.errordesc = response.errordesc || response.msg || err.response.data.message;

    const code = ~~response.errorcode;

    const alertFunc = (message, bolRedirect = true) => {
        this.isLoginOut = true;
        vue.$alert(message, "提示", {
            confirmButtonText: "确定",
            callback: () => {
                // this.isLoginOut = false;
                window.location.replace(window.location.origin + "/login");
                // bolRedirect && (window.location.href = "/login?redirect_uri=" + encodeURIComponent(window.location.pathname + window.location.search ));
            }
        });
    };

    // alertFunc(err.response.data.message, true);

    // isLoginOut 限制多次请求只输出一次错误提示
    if (!this.isLoginOut && err.config && !err.config.hideMessage) {
        switch (code) {
            case 500:
                alertFunc(response.errordesc, false);
                break;
            case 201:
                alertFunc(response.errordesc);
                break;
            // case 1971:
            // 	alertFunc("您的账号已不存在，请联系管理员");
            // 	break;
            // case 1976:
            // 	alertFunc("您的账号已被禁用，请联系管理员");
            // 	break;
            default:
                vue.$message({
                    showClose: true,
                    message: response.errordesc,
                    type: "error"
                });
        }
    }

    return Promise.reject(response);
};

Axios.prototype.request = function (config) {
    showLoading();
    return axios
        .request(config)
        .then(res => this.success(res))
        .catch(err => this.error(err));
};

Axios.prototype.post = function (url = "", body = {}, options = {}) {

    //初始化请求配置参数
    let axiosConfig = new AxiosConfig(url, body, options);
    axiosConfig.method = "post";
    switch (axiosConfig.bodyType) {
        case "form":
            axiosConfig.instance();

            // 固定请求参数放在 body
            Object.assign(axiosConfig.data, axiosConfig.initUrl());

            axiosConfig.headers["Content-Type"] =
                "application/x-www-form-urlencoded;charset=utf-8";
            axiosConfig.transformRequest = [
                data => {
                    return Qs.stringify(data);
                }
            ];
            break;
        case "image":
        case "file":
            axiosConfig.headers["Content-Type"] = "multipart/form-data";
            axiosConfig.timeout = 1800000; //超时时间为半小时

            var formData = new FormData();
            Object.keys(body).map(index => {
                formData.append(index, body[index]);
            });
            axiosConfig.data = formData;
            break;
        default:
            // 默认json格式请求
            axiosConfig.instance();

            // 固定请求参数放在 headers
            Object.assign(axiosConfig.headers, axiosConfig.initUrl());
    }

    return this.request(axiosConfig);
};

Axios.prototype.get = function (url = "", body = {}, options = {}) {
    let axiosConfig = new AxiosConfig(url, body, options);
    axiosConfig.method = "get";
    axiosConfig.params = body;
    // 默认json格式请求
    axiosConfig.instance();

    // 固定请求参数放在 headers
    Object.assign(axiosConfig.headers, axiosConfig.initUrl());
    return this.request(axiosConfig);
    // return this.request({
    // 	url: url,
    // 	method: "get",
    // 	params: body
    // });
};


function AxiosConfig(url = "", body = {}, options = {}) {
    // 发送请求的地址
    this.url = url;

    // 发送请求的数据
    this.data = body;

    // 被发送的自定义请求头
    this.headers = {};

    // 与请求一起发送的 URL 参数
    this.params = {};

    // 自定义的一些参数
    // bodyType: String     请求参数数据类型 支持 json / form / file / image 默认json
    // hideMessage: Boolean 请求失败是否显示错误信息
    // timeout              请求超时时间
    // retry: Number        请求失败重试次数
    // retryDelay: Number   请求失败重试延迟时间
    // retryCount: Number   请求失败已经重试次数
    Object.assign(this, options);
}


AxiosConfig.prototype.instance = function () {
    //默认设置token到请求头
    let userInfo = store.getters.userInfo;
    // 用户ID (非必填)
    this.headers.uid = userInfo ? userInfo.id : "";
    // 会话令牌 (非必填)
    this.headers["X-Access-Token"] = userInfo ? userInfo.token : "";
    // 操作系统平台 ios android web
    this.headers.os = "web";
    // os为web的扩展字段 pc端传值：pc , 手机端传值：mobile
    this.headers.c = "pc";
    // 手机操作系统
    // this.headers.s = "";
    // 浏览器c
    this.headers.browse = window.navigator.appName;
    // user agent
    this.headers.ua = window.navigator.userAgent;
    // 外部展 示版本号(1.0.0)
    this.headers.b = "1.0.0";

    /** 上述参数中非必选的参数，在能拿到信息的情况下都需要传入接口。 */

    this.headers["Content-Type"] = "application/json;charset=utf-8";
};

AxiosConfig.prototype.initUrl = function () {

};

Vue.prototype.$axios = new Axios();

Vue.use(VueAxios, axios);
